<div class="content">
  <div class="icon" [innerHTML]="icon"></div>
  <div class="message">Project created successfully!</div>
</div>

<div class="actions">
  <button class="iconf-btn-filled minh40 minw150" type="button" (click)="closeAndViewProject()">view project</button>
  <button class="iconf-btn-filled minh40 minw150" type="button" (click)="navigateToAddMembers()">continue</button>
</div>
